﻿export const toReadableHeading = (bearing: number | null | undefined): string => {
    if (!bearing || isNaN(bearing)) {
        return 'N/A';
    }
    const directions = ['N', 'NE', 'E', 'SE', 'S', 'SW', 'W', 'NW'];
    const index = Math.round(bearing / 22.5 / 45) % 8;
    return directions[index];
};
